<nav
  [hidden]="!isAuthenticated()"
  class="navbar navbar-static-top navtop-centered-navbar"
  role="navigation"
>
  <div class="navbar-header navtop-centered-header">
    <button
      type="button"
      class="navbar-minimalize minimalize-styl-2 btn btn-primary navtop-toggle"
      [class.navtop-toggle-active]="sidebarCollapsed()"
      (click)="toggleSidebar()"
      aria-label="Toggle navigation menu"
      [attr.aria-pressed]="sidebarCollapsed()"
    >
      <i class="fa fa-bars"></i>
    </button>
    @if (tournaments().length > 0) {
    <div class="navtop-centered-btns">
      <div class="btn-group">
        <button
          data-toggle="dropdown"
          class="btn btn-primary btn-outline dropdown-toggle"
        >
          {{ selectedTournament()?.name }}
          <span class="caret"></span>
        </button>
        <ul class="dropdown-menu">
          @for (t of tournaments(); track t.tournamentId) {
          <li>
            <a href="#" (click)="selectTournament(t); $event.preventDefault()">
              <span>{{ t.name }}</span>
              @if (t.active) {
              <span class="check-icon"
                ><i class="fa fa-check"></i
              ></span>
              }
            </a>
          </li>
          }
        </ul>
      </div>
      <div class="btn-group">
        <button
          data-toggle="dropdown"
          class="btn btn-primary btn-outline dropdown-toggle"
        >
          Round {{ selectedRound()?.number || "" }}
          <span class="caret"></span>
        </button>
        <ul class="dropdown-menu">
          @for (r of rounds(); track r.roundId) {
          <li>
            <a href="#" (click)="selectRound(r); $event.preventDefault()">
              <span>Round {{ r.number }}</span>
              @if (r.active) {
              <span class="check-icon"
                ><i class="fa fa-check"></i
              ></span>
              }
            </a>
          </li>
          }
        </ul>
      </div>
    </div>
    }
  </div>
  <ul class="nav navbar-top-links navbar-right navtop-logout">
    <li>
      <a id="logoutButton" href="#" (click)="logout()">
        <i class="fa fa-sign-out"></i> Log out
      </a>
    </li>
  </ul>
</nav>
